export default __webpack_public_path__ + "static/media/logo.cd763066.png";